export default "__VITE_ASSET__ccd553ce__"